import { guideOrgPackListFun, orgGuidPackagesCount } from '../../../../api/orgGuidAPI';
import errorHandle from '../../../../utils/errorHandle';

export const orgfetchGuidPackList = async (setGuidData, status, limit, offset, setLoading) => {
    try {
        setLoading(true);
        const result = await guideOrgPackListFun(status, limit, offset);
        setGuidData(result.data);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    } finally {
        setLoading(false);
    }
};

export const countOfGuidePackages = async (setTotalCount, selectedStatus, setLoading) => {
    setLoading(true);
    try {
        const res = await orgGuidPackagesCount(selectedStatus);
        setTotalCount(res.data.tourCount);
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};
